export const LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE = {
  JOB: getText('Jobs'),
  INTERNSHIP: getText('Internships'),
  VOLOP: getText('Volunteer +'),
  ORG: getText('Organizations'),
  GROUP: getText('Mutual Aid Groups'),
  IDEALIST_DAY_EVENT: getText('Idealist Days'),
  GRAD_PROGRAM: getText('Graduate Programs'),
};
